import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthHandlers } from "@/lib/api";
import { toast } from "sonner";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

const FULL = "rcud";
const PERMS = {
  admin: { "*": FULL },
  gestore_utenti: { "*": FULL },
  collaboratore: { trusts: "ru", subjects: "r", trust_subjects: FULL, assets: FULL, accounting: FULL, deadlines: FULL,
    fiscal: FULL, diary: FULL, documents: "rcu", chart_of_accounts: "r", prospects: FULL },
  commercialista: { trusts: "r", subjects: "ru", trust_subjects: "r", assets: "r", accounting: "r", deadlines: "r",
    fiscal: "r", diary: "r", documents: "rc", chart_of_accounts: "r" },
  cliente: { trusts: "r", subjects: "r", trust_subjects: "r", assets: "r", deadlines: "r", documents: "r" },
};

export const ROLE_LABELS = {
  admin: "Amministratore", gestore_utenti: "Gestore Utenti", commercialista: "Commercialista",
  collaboratore: "Collaboratore", cliente: "Cliente",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [aupNeeded, setAupNeeded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setAupNeeded(!data.aup_accepted_at);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    setAuthHandlers(
      (detail) => {
        setUser((u) => {
          if (u) toast.error(detail || "Sessione scaduta, effettua di nuovo l'accesso");
          return false;
        });
      },
      () => setAupNeeded(true)
    );
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* sessione già chiusa */ }
    setUser(false);
  };

  const can = (section, action = "r") => {
    if (!user) return false;
    const p = PERMS[user.role] || {};
    return (p[section] ?? p["*"] ?? "").includes(action);
  };
  const hasRole = (...roles) => user && roles.includes(user.role);

  return (
    <AuthCtx.Provider value={{ user, setUser, refresh, logout, can, hasRole, aupNeeded, setAupNeeded }}>
      {children}
    </AuthCtx.Provider>
  );
}
